var isCapacitor = function () {
    try {
        return window.Capacitor && (window.Capacitor.platform === "android" || window.Capacitor.platform === "ios") || window.forceCapacitor;
    }
    catch (error) {
        return false;
    }
};
export default isCapacitor;
//# sourceMappingURL=isCapacitor.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/tools/dist/functions/isCapacitor.js
// module id = 83
// module chunks = 1